/**
 * SkeletonLoader Component
 * Animated loading skeleton for expense cards
 */

import React from 'react';
import './SkeletonLoader.css';

interface SkeletonLoaderProps {
  count?: number;
}

const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({ count = 1 }) => {
  return (
    <div className="skeleton-loader-container">
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="skeleton-card">
          <div className="skeleton-card-header">
            <div className="skeleton-line skeleton-title"></div>
            <div className="skeleton-line skeleton-amount"></div>
          </div>
          <div className="skeleton-card-body">
            <div className="skeleton-row">
              <div className="skeleton-line skeleton-label"></div>
              <div className="skeleton-line skeleton-value"></div>
            </div>
            <div className="skeleton-row">
              <div className="skeleton-line skeleton-label"></div>
              <div className="skeleton-line skeleton-value"></div>
            </div>
            <div className="skeleton-row">
              <div className="skeleton-line skeleton-label"></div>
              <div className="skeleton-line skeleton-badge"></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SkeletonLoader;
